import React, { useState } from 'react';
import { LayoutChangeEvent, Pressable, View } from 'react-native';

import * as theme from '../theme';

export const OverlayContext = React.createContext<{
  isOpen: boolean;
  setElement: (element: JSX.Element | undefined) => void;
  setPosition: (position: LayoutChangeEvent) => void;
  toggleIsVisible: () => void;
}>({ isOpen: false, setElement: () => {}, setPosition: () => {}, toggleIsVisible: () => {} });

export function OverlayProvider({ children }: { children: JSX.Element }): JSX.Element {
  const [element, setElement] = useState<JSX.Element | undefined>();
  const [position, setPosition] = useState<LayoutChangeEvent['nativeEvent']['layout']>();

  const handleSetPosition = (event: LayoutChangeEvent): void =>
    setPosition(event.nativeEvent.layout);

  const toggleIsVisible = (): void => setElement(undefined);

  return (
    <OverlayContext.Provider
      value={{
        isOpen: Boolean(element),
        setElement,
        setPosition: handleSetPosition,
        toggleIsVisible,
      }}>
      {element && (
        <Pressable
          onPress={toggleIsVisible}
          style={[theme.absolute, theme.inset(0), theme.zIndex(1)]}
        />
      )}
      {children}
      <View style={[theme.absolute, position, theme.zIndex(1)]}>{element}</View>
    </OverlayContext.Provider>
  );
}
